/**
 * Тексты сущностей из конфигурации (предметы, сундуки, миссии…). Ключ строит бэк по схеме
 * `<prefix>.<id>.<field>` (I18nEntityKeys), английский — из самой сущности, поэтому он же fallback:
 *   entityText(t, 'shop_item', item.id, 'name', item.name)
 * Префиксы: achievement_config, battle_pass_season, character_module, character (id = код героя, BATMAN),
 * chest_type, key_type, datum_pass_product, lair_building, lair_resource, mission_config,
 * module_rank (id = rank), reward, shop_boost, shop_item, shop_pack, task, merge_fragment.
 */
export const entityText = (t, prefix, id, field, fallback) => {
  if (id === null || id === undefined || id === '' || !fallback) return fallback;
  return t(`${prefix}.${id}.${field}`, { defaultValue: fallback });
};

/** Имя героя по коду (BATMAN → «Бэтмен»); fallback — код с заглавной буквы. */
export const characterName = (t, code) => {
  if (!code) return code;
  const fallback = code.charAt(0) + code.slice(1).toLowerCase();
  return t(`character.${code}.name`, { defaultValue: fallback });
};
